import Close from '@mui/icons-material/Close'
import {
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import type { FC } from 'react'

type Props = {
  onClose: () => void
  canSubmit: boolean
  onSave: () => void
}

export const DrawerHeader: FC<Props> = ({ onClose, canSubmit, onSave }) => {
  const theme = useTheme()
  return (
    <Stack
      bgcolor="background.paper"
      p={1}
      height={64}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      borderBottom={`1px solid ${theme.palette.divider}`}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{ color: 'text.secondary' }}
        >
          <Close color="inherit" sx={{ fontSize: 27 }} />
        </IconButton>
        <Typography
          fontSize={22}
          fontWeight="bold"
          width="fit-content"
          justifySelf="center"
        >
          ラベル
        </Typography>
      </Stack>

      <Tooltip
        title={!canSubmit ? '検査範囲の編集を完了してください' : ''}
        arrow
      >
        <span>
          <Button
            variant="text"
            size="large"
            color="primary"
            disabled={!canSubmit}
            onClick={onSave}
          >
            保存
          </Button>
        </span>
      </Tooltip>
    </Stack>
  )
}
